import React, { Fragment, useEffect } from "react";
import Header from "../../Header/Header";
import PageTitle from "../../pagetitle/PageTitle";
import Footer from "../../footer/Footer";
import Scrollbar from "../../scrollbar/scrollbar";
import DataIntel from "./DataIntel";

const DataIntelsinglepage: React.FC = () => {
    useEffect(() => {
        document.title = "Data & Intelligence | Brain Machine AI";
      }, []);
    return (
        <Fragment>
            <div className='about-page inner-page'>
                <div className="body_wrap o-clip">
                    <Header />
                    <main>
                    <PageTitle pageTitle="Data & Intelligence" pagesub="Data & Intelligence" />
                       <DataIntel></DataIntel>
                    </main>
                    <Footer />
                    <Scrollbar />
                </div>
            </div>
        </Fragment>
    );
};

export default DataIntelsinglepage;
